// extracted by mini-css-extract-plugin
module.exports = {"dark":"dot-m__dark__3JktN","light":"dot-m__light__15yug"};